import * as React from 'react';
import Typography from '@mui/material/Typography';
import DoNotStripSpacesSpan from '../../common/DoNotStripSpacesSpan';
import CertifiedBadge from '../../common/CertifiedBadge';
import useGlynt from '../../hooks/useGlynt';
import { IExtractionBatch } from '../../../types/my-types';
import { getIdFromUrl } from '../../../utils/getIdFromUrl';
import { useQuery } from '@tanstack/react-query';

interface TitleDetailsProps {
  cypressId?: string;
  extractionBatch: IExtractionBatch;
  groupId?: string;
  getTrainingSetName?: boolean;
}

const TitleDetails: React.FC<TitleDetailsProps> = ({
  cypressId,
  extractionBatch,
  groupId,
  getTrainingSetName,
}) => {
  const glynt = useGlynt();
  const tsId = groupId || getIdFromUrl(extractionBatch!.training_set);

  // TODO: display revision label | Revision: ${trainingRevision.trainingRevision.label}`}

  const {
    data: trainingSet,
    isPending,
    isError,
  } = useQuery({
    queryKey: ['trainingSet', tsId],
    queryFn: async () => await (await glynt).trainingSet.retrieve(tsId),
    enabled: tsId !== 'unclassified' && tsId.length > 0
  });
  if (isPending) {
    return null;
  }
  if (isError) {
    return <p>Sorry, something went wrong.</p>;
  }

  const displayTrainingSetName = () => {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
        <span>
          Training Set:{' '}
          <DoNotStripSpacesSpan
            title={trainingSet?.label || ''}
            cypressId={`extraction-batch-details-training-set-${trainingSet?.label}`}
          />
        </span>
        <CertifiedBadge
          certifiedAt={trainingSet?.certified_at}
          certifiedBy={trainingSet?.certified_by}
        />
      </span>
    );
  };

  return (
    <Typography variant="h5" data-cy={cypressId ? cypressId : null}>
      {getTrainingSetName ? (
        tsId.length === 0 ? (
          'Auto-Classify'
        ) : tsId === 'unclassified' ? (
          'Unclassified'
        ) : (
          displayTrainingSetName()
        )
      ) : (
        <DoNotStripSpacesSpan
          title={extractionBatch!.label}
          cypressId={`extraction-batch-details-label=${extractionBatch!.label}`}
        />
      )}
    </Typography>
  );
};

export default TitleDetails;
